import { Component } from '@wix/thunderbolt-becky-types'
import { envRefs } from '@wix/thunderbolt-catharsis'
import { createCssCompNode } from '../cssCompNode'
import { FeatureRefs } from '../cssFeatures.types'
import { isMasterPage, isPageComponent, isRefComponent } from './zIndexCompNodeHelpers'
import { getClassicZIndexValues } from './zIndexCompNodeClassicHelpers'
import { getResponsiveZIndexValues } from './zIndexCompNodeResponsiveHelpers'
import { ZIndexCssChild, ZIndexPageChildren } from './zIndexCss.types'
import { PageDefinition } from '@wix/thunderbolt-components-native'

const getChildren = (comp: Component, refs: FeatureRefs<'zIndexCss'>) => {
	return (comp.components || []).map(refs.defaultZIndexCss)
}

export const defaultZIndexCss = (isEditor: boolean) =>
	createCssCompNode('zIndexCss', 'defaultZIndexCss', {
		getDependencies: (component: Component, refs: FeatureRefs<'zIndexCss'>) => {
			// Checking if we are parents of a page or a master page
			if (isPageComponent(component) || isMasterPage(component)) {
				return {
					compData: refs.dataQuery<PageDefinition['data']>(component.dataQuery!),
					pageOriginalChildren: getChildren(component, refs),
					isMobileView: envRefs.isMobileView,
					isOneDocMigrated: envRefs.isOneDocMigrated,
					hasResponsiveLayout: refs.hasResponsiveLayout(component),
				}
			}
			return {
				refCompChildren: isRefComponent(component) ? getChildren(component, refs) : null,
				compLayouts: component.layoutQuery ? refs.compLayouts(component) : null,
				isOneDocMigrated: envRefs.isOneDocMigrated,
				compSingleLayout: refs.compSingleLayout(component),
				pinnedStyle: refs.pinnedStyle(component),
				hasResponsiveLayout: refs.hasResponsiveLayout(component),
			}
		},
		toViewItem: (component, deps) => {
			// Checking if it's not a page container which is rendering it's children
			if (!isPageComponent(component) && !isMasterPage(component)) {
				const { compSingleLayout } = deps

				return {
					component,
					refCompChildren: deps?.refCompChildren,
					compLayouts: deps?.compLayouts,
					...(compSingleLayout
						? {
								compSingleLayout,
								pinnedStyle: compSingleLayout.itemLayout?.type === 'FixedItemLayout',
						  }
						: {
								pinnedStyle: !!deps?.pinnedStyle,
						  }),
				} as ZIndexCssChild
			}

			// remove null / undefined children
			const pageOriginalChildren = (deps?.pageOriginalChildren?.filter(Boolean) || []) as ZIndexPageChildren

			return deps.hasResponsiveLayout
				? getResponsiveZIndexValues(component, pageOriginalChildren, isEditor)
				: getClassicZIndexValues(
						component,
						pageOriginalChildren,
						deps.isMobileView || false,
						deps.compData?.isPopup || false,
						deps.isOneDocMigrated
				  )
		},
	})
